var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinesses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#162B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.08 33.34C78.53 32.81 77.81 32.5 77 32.5H23C22.19 32.5 21.46 32.81 20.92 33.34C20.35 33.88 20 34.65 20 35.5V74.5C20 76.15 21.34 77.5 23 77.5H77C78.65 77.5 80 76.15 80 74.5V35.5C80 34.65 79.65 33.88 79.08 33.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 22.5H40C37.24 22.5 35 24.74 35 27.5V32.5H40V30C40 28.62 41.12 27.5 42.5 27.5H57.5C58.88 27.5 60 28.62 60 30V32.5H65V27.5C65 24.74 62.76 22.5 60 22.5Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 55H40V57.5C40 58.88 38.88 60 37.5 60C36.12 60 35 58.88 35 57.5V55Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 55H65V57.5C65 58.88 63.88 60 62.5 60C61.12 60 60 58.88 60 57.5V55Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 32.5H23C21.3431 32.5 20 33.8431 20 35.5V52C20 53.6569 21.3431 55 23 55H77C78.6569 55 80 53.6569 80 52V35.5C80 33.8431 78.6569 32.5 77 32.5Z",
    fill: "#E2F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0001 55.38H23.0001C21.1401 55.38 19.6201 53.87 19.6201 52V35.5C19.6201 33.64 21.1301 32.12 23.0001 32.12H77.0001C78.8601 32.12 80.3801 33.63 80.3801 35.5V52C80.3801 53.86 78.8701 55.38 77.0001 55.38ZM23.0001 32.88C21.5501 32.88 20.3801 34.06 20.3801 35.5V52C20.3801 53.45 21.5601 54.62 23.0001 54.62H77.0001C78.4501 54.62 79.6201 53.44 79.6201 52V35.5C79.6201 34.05 78.4401 32.88 77.0001 32.88H23.0001Z",
    fill: "#4782FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinesses);
export default __webpack_public_path__ + "static/media/businesses.dfd3ee6665afe6965a2c1262f59c8c45.svg";
export { ForwardRef as ReactComponent };